
import CryptoJS from 'crypto-js';



export const apicode = {

  async _code(payload) {


    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), import.meta.env.VITE_VERSAO).toString();

    //  console.log('Encrypted:', encrypted);
    return encrypted;



  },

  _decode(token) {

    const decrypted = CryptoJS.AES.decrypt(token, import.meta.env.VITE_VERSAO).toString(CryptoJS.enc.Utf8);

    // console.log('Decrypted:', decrypted);
    return JSON.parse(decrypted);

  }


}

